import type { CSSProperties, ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  bg?: string;
  color?: string;
  style?: CSSProperties;
}

/** Tag pequena e arredondada (status, tipo, categoria). */
export function Badge({ children, bg, color, style }: BadgeProps) {
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 700,
        padding: "3px 9px",
        borderRadius: 12,
        background: bg,
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
